/* eslint-disable*/

import React from "react";

const StatCard = ({ number, label }) => (
  <div style={{
    display: "flex",
    alignItems: "center",
    margin: "1rem",
    minWidth: 220,
    flex: "1 1 250px",
    maxWidth: 350,
  }}>
    <div style={{
      minWidth: 70,
      minHeight: 70,
      borderRadius: "50%",
      background: "#91ea23ff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 36,
      color: "#fff",
      fontWeight: "bold",
      flexShrink: 0,
      // boxShadow: "0 1px 5px rgba(0,0,0,0.07)"
      boxShadow: "0 8px 15px rgba(0,0,0,0.25), 0 4px 4px rgba(0,0,0,0.15)"

    }}>
      {number}
    </div>
    <div style={{
      background: "#e4eaf7",
      height: 70,
      minWidth: 110,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      borderTopRightRadius: 6,
      borderBottomRightRadius: 6,
      padding: "0 20px",
      fontSize: 20,
      fontWeight: 500,
      marginLeft: -10,
      // boxShadow: "0 1px 5px rgba(0,0,0,0.05)"
      borderRadius: 10,
      boxShadow: "0 8px 15px rgba(0,0,0,0.25), 0 4px 4px rgba(0,0,0,0.15)"
    }}>
      {label}
    </div>
  </div>
);

export default StatCard;
